//constants
import { MAX_COLOR, TEXT_MORE } from './constants';

export const getQuanityMessage = (length: number) =>
  length - MAX_COLOR > 0 ? `+${length - MAX_COLOR} ${TEXT_MORE}` : '';

// Convert hex color to readable color name for accessibility
export const getColorName = (hexColor: string): string => {
  if (!hexColor || !hexColor.startsWith('#')) return 'color';

  const hex = hexColor.toLowerCase();

  // Common color mappings
  const colorMap: { [key: string]: string } = {
    '#000000': 'black',
    '#ffffff': 'white',
    '#ff0000': 'red',
    '#00ff00': 'green',
    '#0000ff': 'blue',
    '#ffff00': 'yellow',
    '#ff00ff': 'magenta',
    '#00ffff': 'cyan',
    '#808080': 'gray',
    '#c0c0c0': 'silver',
    '#800000': 'maroon',
    '#808000': 'olive',
    '#008000': 'dark green',
    '#800080': 'purple',
    '#008080': 'teal',
    '#000080': 'navy',
    '#ffa500': 'orange',
    '#ffc0cb': 'pink',
    '#a52a2a': 'brown',
    '#f5f5dc': 'beige',
    '#daa520': 'golden',
    '#4b0082': 'indigo',
    '#ee82ee': 'violet',
    '#f0e68c': 'khaki',
    '#e6e6fa': 'lavender',
    '#ffe4e1': 'misty rose',
    '#faebd7': 'antique white',
    '#faf0e6': 'linen',
    '#fff5ee': 'seashell',
  };

  // Check exact match first
  if (colorMap[hex]) {
    return colorMap[hex];
  }

  // Convert hex to RGB to determine approximate color
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  // Determine if it's a shade of gray
  if (Math.abs(r - g) < 30 && Math.abs(g - b) < 30 && Math.abs(r - b) < 30) {
    if (r < 50) return 'black';
    if (r > 200) return 'white';
    if (r < 100) return 'dark gray';
    if (r < 150) return 'gray';
    return 'light gray';
  }

  // Determine dominant color
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);

  // Check if color is very dark or very light
  const isDark = max < 100;
  const isLight = min > 180;
  const prefix = isDark ? 'dark ' : isLight ? 'light ' : '';

  if (r === max) {
    if (g > b && g > 100) return `${prefix}orange`;
    if (b > g && b > 100) return `${prefix}pink`;
    return `${prefix}red`;
  }

  if (g === max) {
    if (b > 150) return `${prefix}cyan`;
    if (r > 150) return `${prefix}yellow`;
    return `${prefix}green`;
  }

  if (b === max) {
    if (r > 150) return `${prefix}purple`;
    if (g > 100) return `${prefix}teal`;
    return `${prefix}blue`;
  }

  return 'color';
};
